module.exports = __webpack_public_path__ + "img/vitor-pinto-3t_L1Carpx8-unsplash.03e84818.jpg";